<div class="input-context-search">
  <input
    class="search"
    [placeholder]="placeholderText"
    (keyup)="applyFilter($event)"
  />
  <mat-icon class="search-users-list"></mat-icon>
</div>
